
import { FC } from 'react';

import { Alert } from 'antd';
import { AlertProps } from 'antd/lib';

import './index.css';

interface CustomAlertProps extends AlertProps {
    message: string | React.ReactNode;
    type: 'error' | 'success' | 'info' | 'warning';
    description?: string | React.ReactNode;
    className?: string;
}

export const AlertComponent: FC<CustomAlertProps> = ({ message, type, description, className }) => 
    <Alert
        className={`withholding-list__error-alert ${className}`}
        message={<b>{message}</b>}
        type={type}
        showIcon
        description={description}
        banner={true}
    />
